'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var getPrototypeOf = require('./getPrototypeOf.js');

var isNativeReflectConstruct = require('./isNativeReflectConstruct.js');

var possibleConstructorReturn = require('./possibleConstructorReturn.js');

function _createSuper(Derived) {
  var hasNativeReflectConstruct = isNativeReflectConstruct['default']();
  return function _createSuperInternal() {
    var Super = getPrototypeOf['default'](Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = getPrototypeOf['default'](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return possibleConstructorReturn['default'](this, result);
  };
}

exports['default'] = _createSuper;